module.exports = __webpack_public_path__ + "media/images/ac_templates/201/rog-c39c30f1f8000132f28094405782381f.jpg";